<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
          <div class="top_p">
            <p class="top_cent_p">
              <i class="el-icon-location"></i>
              <span>天津</span>
              <i class="el-icon-arrow-down icon"></i>
            </p>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{path:'/'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li>登陆 | 注册</li>
            <li>商会后台</li>
            <li>卖家中心</li>
            <li>政府机构</li>
            <li>
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="cent">
      <div class="cent_1">
        <div class="cent_top">
          <div class="cent_top_content">
            <img src="../../assets/img/dingdan/pay_icon_order.png" alt />
            <p>订单号：{{lists.order_sn}}</p>
          </div>
        </div>
        <div class="cent_bottom">
          <div class="cent_bottom_1">
            <ul>
              <li>
                <img src="../../assets/img/dingdan/pay_icon_step01_sel.png" alt />
                <p>沟通需求</p>
              </li>
              <li>
                <i class="el-icon-arrow-right"></i>
              </li>
              <li>
                <img src="../../assets/img/dingdan/pay_icon_step02_sel.png" alt />
                <p>下单预付</p>
              </li>
              <li>
                <i class="el-icon-arrow-right"></i>
              </li>
              <li>
                <img src="../../assets/img/dingdan/pay_icon_step03_sel.png" alt />
                <p>为您服务</p>
              </li>
              <li>
                <i class="el-icon-arrow-right"></i>
              </li>
              <li>
                <img src="../../assets/img/dingdan/pay_icon_step04_nor.png" alt />
                <p>验收服务</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="content_1">
        <div class="content_one">
          <div class="content_one1">
            <p>任务详情</p>
            <p>联系商家：{{lists.phone}}</p>
          </div>
          <div class="content_one2">
            <div class="content_one2_left">
              <div class="content_one2_right1">
                <p>需求标题</p>
                <p>{{lists.service_name}}</p>
              </div>
              <div class="content_one2_right1">
                <p>任务需求</p>
                <p style="width:682px;">{{lists.remark_member}}</p>
              </div>
              <div class="content_one2_right1">
                <p>订单金额</p>
                <p style="color:#F7681E;font-weight:600;margin-right:50px;">￥{{lists.goods_price}}</p>
                <span>服务商已收</span>
                <span
                  style="color:#F7681E;font-weight:600;margin-right:50px;"
                >-￥{{lists.provider_price}}</span>
                <span>托管服务费</span>
                <span style="color:#F7681E;font-weight:600;margin-right:30px;">￥{{lists.host_price}}</span>
              </div>
              <div class="fuwudaoqi">
                <p>服务到期时间：2019年11月25日</p>
              </div>
            </div>
            <div class="content_one2_right">
              <div class="content_one2_right1">
                <p>需求类型</p>
                <p>{{lists.service_name}}</p>
              </div>
              <div class="content_one2_right1">
                <p>下单时间</p>
                <p>{{lists.create_time}}</p>
              </div>
              <div class="content_one2_right1">
                <p>支付时间</p>
                <p>{{lists.pay_time}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="content_two">
          <div class="content_botom_1">
            <el-button type="primary" @click="dialogVisible3 = true" class="bot">追加服务费</el-button>
            <el-button type="primary" @click="dialogVisible2 = true" class="bot">补充需求</el-button>
            <el-button type="primary" class="bot">补充合同</el-button>
            <el-button type="primary" @click="dialogVisible = true" class="bot">查看合同</el-button>
          </div>
        </div>
        <div class="content_tree" v-if="lists.is_acceptance == 2">
          <p>等待服务商发起验收</p>
          <el-button type="primary" class="bott">验收</el-button>
        </div>
        <div class="content_tree_1" v-else>
          <p class="content_tree_p">验收申请</p>
          <div class="content_one2">
            <div class="content_one2_left">
              <div class="content_one2_right1">
                <p>验收金额</p>
                <p style="color:#F7681E;font-weight:600;margin-right:50px;">￥{{lists.goods_price}}</p>
              </div>
              <div class="content_one2_right1">
                <p>验收说明</p>
                <p style="width:682px;">{{lists.remark_member}}</p>
              </div>
              <div class="content_one2_right1">
                <p></p>
                <p></p>
              </div>
            </div>
            <div class="content_one2_right_1">
              <p>
                <el-button type="primary" class="button" @click="dialogVisible1 = true">拒绝验收</el-button>
              </p>
              <p>
                <el-button type="primary" class="button_1" @click="acceptance()">同意验收</el-button>
              </p>
            </div>
          </div>
        </div>
        <div class="content_four" v-if="orderD != ''">
          <div class="content_four_1">
            <p class="content_four_1_1">服务费记录</p>
            <p class="content_four_1_2">
              订单金额&nbsp;&nbsp;&nbsp;
              <span style="color:#F7681E;">￥{{lists.goods_price}}</span>
            </p>
            <p class="content_four_1_2">
              服务商已收
              <span style="color:#F7681E;">-￥{{lists.provider_price}}</span>
            </p>
            <p class="content_four_1_2">
              托管服务费
              <span style="color:#F7681E;">￥{{lists.host_price}}</span>
            </p>
          </div>
          <div class="content_four_2">
            <div class="content_four_one">
              <div
                class="content_four_one1"
                v-for="(item,index) in orderD.service_log"
                :key="index"
              >
                <ul>
                  <li>{{item.update_time}}</li>
                  <li></li>
                  <li>
                    <p class="four_one_P">追加服务费￥{{item.edit_price}}</p>
                    <!-- <p
                      class="four_one_P1"
                    >验收说明：第一阶段的内容已完成交付，请您验收，验收后我们将开始第二阶段的服务，为了能尽快为您服务，请您及时进行验收操作，谢谢。</p>
                    <p class="four_img"></p>-->
                  </li>
                </ul>
              </div>
              <!-- <div class="content_four_one1">
                <ul>
                  <li>2019.11.20 15:20:45</li>
                  <li></li>
                  <li>
                    <p class="four_one_P">已验收￥500.00</p>
                    <p
                      class="four_one_P1"
                    >验收说明：第一阶段的内容已完成交付，请您验收，验收后我们将开始第二阶段的服务，为了能尽快为您服务，请您及时进行验收操作，谢谢。</p>
                    <p class="four_img"></p>
                  </li>
                </ul>
              </div>
              <div class="content_four_one1">
                <ul>
                  <li>2019.11.20 15:20:45</li>
                  <li></li>
                  <li>
                    <p class="four_one_P">已验收￥500.00</p>
                    <p
                      class="four_one_P1"
                    >验收说明：第一阶段的内容已完成交付，请您验收，验收后我们将开始第二阶段的服务，为了能尽快为您服务，请您及时进行验收操作，谢谢。</p>
                    <p class="four_img"></p>
                  </li>
                </ul>
              </div>
              <div class="content_four_one1">
                <ul>
                  <li>2019.11.20 15:20:45</li>
                  <li></li>
                  <li>
                    <p class="four_one_P">已验收￥500.00</p>
                    <p
                      class="four_one_P1"
                    >验收说明：第一阶段的内容已完成交付，请您验收，验收后我们将开始第二阶段的服务，为了能尽快为您服务，请您及时进行验收操作，谢谢。</p>
                    <p class="four_img"></p>
                    <p class="four_one_P1">拒绝理由：第一阶段内容还未完成，请贵公司与我方沟通以便及时改正</p>
                  </li>
                </ul>
              </div>
              <div class="content_four_one1">
                <ul>
                  <li>2019.11.20 15:20:45</li>
                  <li></li>
                  <li>
                    <p class="four_one_P">首次托管服务费￥500.00</p>
                  </li>
                </ul>
              </div>-->
              <!-- <div class="kong"></div> -->
            </div>
          </div>
        </div>

        <div class="content_four">
          <div class="content_four_1">
            <p class="content_four_1_1">需求记录</p>
            <p class="content_four_1_1p">{{lists.remark_member}}</p>
          </div>
          <div class="content_four_2">
            <div class="content_four_one">
              <div class="content_four_one1" v-for="(item,index) in getorder" :key="index">
                <ul>
                  <li>2019.11.20 15:20:45</li>
                  <li></li>
                  <li>
                    <p class="four_one_P">补充需求</p>
                    <p class="four_one_P1">{{item.remark_member}}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li @click="floor()">
            <a href="#">关于商企服</a>
          </li>
          <li @click="leimu()">
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>
    <el-dialog
      title
      :visible.sync="dialogVisible"
      width="960px"
      v-if="contract.contract_type == '1'"
    >
      <div class="chakan" slot="title">
        <img src="../../assets/img/dingdan/hetong/pop_img_contract top.png" alt />
      </div>
      <div class="con">
        <div class="con_1">
          <div class="con_one" v-if="contract.status == '未签署'">
            <div class="con_one_1">
              <img src="../../assets/img/dingdan/hetong/pop_icon_contract time.png" alt />
              <p>合同未签署</p>
            </div>
            <div class="con_one_2">
              <el-button class="button_he">签署合同</el-button>
              <el-button class="button_he" style="background: #007BFF;">下载合同</el-button>
            </div>
          </div>
          <div class="con_one" v-if="contract.promoter_identity == '1'">
            <div class="con_one_1">
              <img src="../../assets/img/dingdan/hetong/pop_icon_contract time.png" alt />
              <p>合同待签署</p>
            </div>
            <div class="con_one_2">
              <el-button class="button_he" plain>拒绝签署</el-button>
              <el-button class="button_he">签署合同</el-button>
              <el-button class="button_he" style="background: #007BFF;">下载合同</el-button>
            </div>
          </div>
          <div class="con_one" v-if="contract.status == '1'">
            <div class="con_one_1">
              <img src="../../assets/img/dingdan/hetong/pop_icon_contract time.png" alt />
              <p>等待服务商签署</p>
            </div>
            <div class="con_one_2">
              <el-button class="button_he" style="background: #007BFF;" @click="create()">下载合同</el-button>
            </div>
          </div>
          <div class="con_two">
            <div class="con_two_1">
              <div class="con_two_2">
                <p>合同说明:</p>
                <p>雇主与服务商应当充分沟通、并在合同中明确服务项目的具体内容，如项目描述、产品功能描述、服务要求等。本合同为线上.合同，以此作为平台维护双方利益的依据。</p>
              </div>
            </div>
          </div>
          <div class="con_three">
            <div class="con_three_1">
              <div class="con_three_top">
                <p>服务内容</p>
              </div>
              <div class="con_three_top1">
                <p class="con_three_top1_p">{{contract.service_content}}</p>
                <div class="content_one2_right1">
                  <p>服务工期:</p>
                  <p>{{contract.start_time}} 至 {{contract.end_time}}</p>
                </div>
                <div class="content_one2_right1">
                  <p>服务费:</p>
                  <p>{{contract.goods_price}}</p>
                </div>
              </div>
              <div class="con_three_top">
                <p>服务阶段</p>
              </div>
              <div class="con_three_top2">
                <!-- <el-table :data="contracts[0]" style="height:192px;padding: 0 0 0 30px;">
                  <el-table-column prop="content" label="项目阶段" width="200" height="63"></el-table-column>
                  <el-table-column prop="content" label="阶段内容" width="250" height="63"></el-table-column>
                  <el-table-column prop="content" label="所需工时" height="63"></el-table-column>
                  <el-table-column prop="content" label="付款金额" height="63"></el-table-column>
                </el-table>-->
                <ul class="ul_nian">
                  <li>
                    <p>项目阶段</p>
                    <p
                      v-for="(item,index) in contracts"
                      :key="index"
                    >{{contracts[index][0].content}}</p>
                  </li>
                  <li>
                    <p>阶段内容</p>
                    <p
                      v-for="(item,index) in contracts"
                      :key="index"
                    >{{contracts[index][1].content}}</p>
                  </li>
                  <!-- <li>
                    <p>所需工时</p>
                    <p
                      v-for="(item,index) in contracts"
                      :key="index"
                    >{{contracts[index][2].content}}</p>
                  </li> -->
                  <li>
                    <p>付款金额</p>
                    <p
                      v-for="(item,index) in contracts"
                      :key="index"
                    >{{contracts[index][3].content}}</p>
                  </li>
                </ul>
              </div>
              <div class="con_three_top">
                <p>雇主权利义务责任</p>
              </div>
              <div class="con_three_top_3">
                <p>{{contract.member_accountability}}</p>
              </div>
              <div class="con_three_top">
                <p>服务商权利义务责任</p>
              </div>
              <div class="con_three_top_3">
                <p>{{contract.provider_accountability}}</p>
              </div>
              <div class="con_three_top">
                <p>验收标准</p>
              </div>
              <div class="con_three_top_3">
                <p>{{contract.acceptance_criteria}}</p>
              </div>
              <div class="con_three_top">
                <p>违约责任</p>
              </div>
              <div class="con_three_top_3">
                <p>{{contract.default_accountability}}</p>
              </div>
              <div class="con_three_top_p">
                <p>《通用合同》</p>
              </div>
              <div class="con_three_top_4">
                <p
                  style="text-indent:25px;line-height:25px;"
                >本协议由甲方和乙方(商企服服务商）在线签订，请甲方仔细阅读协议内容，勾选接受本协议，即意味着已阅读、理解并接受本协议所有条款，并对本协议各条款及相应的法律后果已全部知晓并充分认可。甲方勾选本协议后，即可产生法律约束力。</p>
                <p>一、定义</p>
                <p style="text-indent:25px;">1、商企服平台：指基于商会的综合性企业服务平台，企业服务(商业服务线上交易)是商企服平台中一个重要功能模块。</p>
                <p style="text-indent:25px;">2、用户：指在商企服平台合法注册，接受相关协议、规则、制度等的会员。</p>
                <p style="text-indent:25px;">3、甲方：指在商企服平台上发布服务需求、购买并支付服务的用户。</p>
                <p style="text-indent:25px;">4、乙方：指在商企服平台提供商业服务的用户，即服务商。</p>
                <p style="text-indent:25px;">5、服务需求：指甲方基于自身需求向乙方提出的具体服务要求。</p>
                <p style="text-indent:25px;">6、服务费：指甲方和乙方的交易金额，即本协议约定的交易金额及后续经协商调整后确定的交易总金额。</p>
                <p style="text-indent:25px;">7、平台账户：指用户在商企服平台上注册的账号，用户只能通过该账号登录商企服平台进行交易。</p>
                <p>二、甲方的权利与义务</p>
                <p
                  style="text-indent:25px;"
                >1、甲方应根据服务需求主动向乙方提交该项目所需的相关资料，并保证资料真实、合法、有效，如因甲方未按照前述标准提供资料导致乙方无法履行协议义务的，由此产生的责任由甲方自行承担。</p>
                <p
                  style="text-indent:25px;"
                >2、甲方有权对服务需求对乙方的服务提出建议和思路，同时有权在验收时对乙方的服务成果提出修改意见，但甲方提出的建议或思路及修改意见应当明确具体，如含糊不清，乙方有权不听取甲方建议或拒绝修改，甲方不得借机拖延进度及应支付的款项，甲方提出超出协议约定范围的修改要求，乙方有权拒绝或另行收费。</p>
                <p style="text-indent:25px;">3、甲方应充分了解且同意遵守商企服平台公布的所有协议、规则、制度等，并按照相关规定处理相关交易事项。</p>
                <p
                  style="text-indent:25px;"
                >4、甲方应及时验收乙方交付的服务成果，包括阶段成果和最终成果，如乙方向甲方提交服务成果后7日内甲方未给出具体验收意见的，视为乙方提交的服务成果合格。如有下一阶段服务的，乙方有权继续推进。如下一阶段服务因甲方愿意导致无法继续推进的，乙方不承担任何责任。</p>
                <p style="text-indent:25px;">5、甲方有义务向乙方提供必要的配合义务，包括提供必要的资料、及时验收、及时回复等。</p>
                <p
                  style="text-indent:25px;"
                >6、甲方应保证委托的服务需求不违反任何法律法规或侵犯他人合法权益，否则乙方有权拒绝提供服务并有权立即解除本协议，甲方已支付服务费作为违约金不予退还。</p>
                <p
                  style="text-indent:25px;"
                >7、甲方应保证合法使用乙方提交的服务成果，不得将服务成果用于任何违法违规或侵犯他人合法权益的活动，如甲方违反，应承担全部责任。</p>
                <p
                  style="text-indent:25px;"
                >8、甲方同意本协议仅作为维护交易内容和双方权利义务的基本约定，具体的服务项目、期限、金额等甲方在商企服平台下单时应与乙方进行约定并/或签订相关合同。</p>
                <p
                  style="text-indent:25px;"
                >9、甲方下单时，应仔细确认所需服务内容、价格、数量等信息，下单后即表示甲方对下单信息的认可，支付成功后订单即生效。</p>
                <p
                  style="text-indent:25px;"
                >10、如乙方未在本协议约定期限内完成工作的，甲方有权拒绝支付全部或部分服务费，甲方对已支付的服务费可申请退款，申请退款48小时内，乙方仍不能提交服务成果的，乙方应同意退款。</p>
                <p>三、乙方的权利与义务</p>
                <p style="text-indent:25px;">1、乙方应按照本协议的约定向甲方提供服务。</p>
                <p
                  style="text-indent:25px;"
                >2、乙方应当积极听取甲方的修改意见，对甲方提出的合理需求及明确的修改意见，乙方应在提供服务成果后提供不超过3次的修改服务，但超出协议约定内容的修改需求乙方有权拒绝。</p>
                <p style="text-indent:25px;">3、乙方应该对甲方提供的相关资料承担保密义务，不得向第三方透露。</p>
                <p style="text-indent:25px;">4、乙方有权要求甲方按照协议约定支付相应服务费，如甲方未按照约定支付的，乙方有权利拒绝或顺延提供服务。</p>
                <p
                  style="text-indent:25px;"
                >5、双方约定分阶段工作的，乙方完成阶段性工作，甲方应在7日内予以验收，验收合格后应及时支付该阶段服务费，如未按约定验收，视为验收合格，乙方有权要求甲方支付已完成阶段服务费。</p>
                <p style="text-indent:25px;">6、乙方应按照法律规定自行缴纳相应税费。</p>
                <p>四、服务费流转和发票</p>
                <p style="text-indent:25px;">1、乙方同意委托商汇（天津）信息技术有限公司代为处理服务费事宜。</p>
                <p style="text-indent:25px;">2、乙方应按照甲方最终实际支付服务费为甲方开具合法有效的发票。</p>
                <p>五、知识产权</p>
                <p
                  style="text-indent:25px;"
                >1、本协议所产生的服务成果的知识产权在甲方支付完全部服务费后，归甲方所有。乙方禁止转让该知识产权，但可将服务成果用于案例展示或参加评选。双方另有约定的除外。</p>
                <p style="text-indent:25px;">2、乙方应保证服务成果不存在侵犯第三方的所有权、知识产权、名誉权、肖像权等，并承担因此产生的全部责任。</p>
                <p
                  style="text-indent:25px;"
                >3、甲方的服务需求如需采购第三方知识产权产品的，乙方应及时告知甲方，取得甲方书面同意且支付采购费用后，乙方予以采购并使用，或由甲方自行采购后提供给乙方使用。</p>
                <p
                  style="text-indent:25px;"
                >4、甲方在未付清所有服务费之前，不得使用服务成果，不得主张知识产权。如甲方违反，导致乙方或其他方损失的，甲方应承担因此产生的全部责任。</p>
                <p>六、责任限制</p>
                <p style="text-indent:25px;">乙方依照法律法规履行义务，但对于下述原因导致的合同履行障碍、延后、变更等情况，乙方不承担违约责任：</p>
                <p style="text-indent:25px;">1、因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；</p>
                <p style="text-indent:25px;">2、因电力供应故障、通讯网络故障等公共服务因素或第三人因素；</p>
                <p style="text-indent:25px;">3、在乙方已尽力管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。</p>
                <p>七、违约责任</p>
                <p
                  style="text-indent:25px;"
                >1、乙方未按本协议约定提交服务成果的，应按照服务项目费用总额的1%/天向甲方支付违约金（可在未付款中扣除），延期达15天及以上的，除双方另有约定外，双方均有权解除协议，乙方已收取的服务费应予退还，同时乙方承担违约金。乙方承担责任以收取的服务费为限，仅在已收取的服务费范围内承担责任。</p>
                <p style="text-indent:25px;">2、甲方在服务期间无正当理由单方终止协议的，已支付服务费无权要求返还。</p>
                <p style="text-indent:25px;">3、乙方在服务期间无正当理由单方终止协议的，所收取服务费应当全部返还甲方。</p>
                <p>八、适用法律与争议解决</p>
                <p style="text-indent:25px;">1、本协议及与本协议有关的争议、解释等，均适用中华人民共和国法律。</p>
                <p style="text-indent:25px;">2、本协议履行过程中，如有争议，双方应当友好协商解决；协商不成，双方一致同意提交当地冲裁委员会进行仲裁。</p>
                <p>九、其他</p>
                <p style="text-indent:25px;">1、本协议以电子文本形式生成，双方勾选本协议后，即表示同意本协议，与手签协议具同等法律效力。</p>
                <p style="text-indent:25px;">2、本协议中的任何约定如违反法律法规而无效的，该条款不影响本协议其他条款的效力。</p>
                <p>十、 本协议由商汇（天津）信息技术有限公司解释，自发布之日起实行。</p>
              </div>
              <div class="con_three_top_5">
                <div class="con_three_bot">
                  <div class="con_p">
                    <p class="con-p">甲方：刘岩</p>
                    <p class="con-p1">签署时间{{contract.create_time}}</p>
                  </div>
                  <img src="../../assets/img/dingdan/hetong/pop_icon_contract wqs.png" alt />
                </div>
                <div class="con_three_bot1">
                  <div class="con_p">
                    <p class="con-p">乙方：商汇（天津）信息技术有限公司</p>
                    <p class="con-p1">签署时间2019/11/19</p>
                  </div>
                  <img src="../../assets/img/dingdan/hetong/pop_icon_contract wqs.png" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title
      :visible.sync="dialogVisible"
      width="960px"
      v-if="contract.contract_type == '2'"
    >
      <div class="chakan" slot="title">
        <img src="../../assets/img/dingdan/hetong/pop_img_contract top.png" alt />
      </div>
      <div class="con1">
        <div class="con1_1">
          <div class="con_one" v-if="contract.status == '未签署'">
            <div class="con_one_1">
              <img src="../../assets/img/dingdan/hetong/pop_icon_contract time.png" alt />
              <p>合同未签署</p>
            </div>
            <div class="con_one_2">
              <el-button class="button_he">签署合同</el-button>
              <el-button class="button_he" style="background: #007BFF;">下载合同</el-button>
            </div>
          </div>
          <div class="con_one" v-if="contract.promoter_identity == '1'">
            <div class="con_one_1">
              <img src="../../assets/img/dingdan/hetong/pop_icon_contract time.png" alt />
              <p>合同待签署</p>
            </div>
            <div class="con_one_2">
              <el-button class="button_he" plain>拒绝签署</el-button>
              <el-button class="button_he">签署合同</el-button>
              <el-button class="button_he" style="background: #007BFF;">下载合同</el-button>
            </div>
          </div>
          <div class="con_one" v-if="contract.status == '1'">
            <div class="con_one_1">
              <img src="../../assets/img/dingdan/hetong/pop_icon_contract time.png" alt />
              <p>等待服务商签署</p>
            </div>
            <div class="con_one_2">
              <el-button class="button_he" style="background: #007BFF;" @click="create()">下载合同</el-button>
            </div>
          </div>
          <div class="con_two">
            <div class="con_two_1">
              <div class="con_two_2">
                <p>合同说明:</p>
                <p>雇主与服务商应当充分沟通、并在合同中明确服务项目的具体内容，如项目描述、产品功能描述、服务要求等。本合同为线上.合同，以此作为平台维护双方利益的依据。</p>
              </div>
            </div>
          </div>
          <div class="con_three1">
            <div class="con_three1_1">
              <div class="con_three_top">
                <p>合同内容</p>
              </div>
              <div class="con_three_top2">
                <img src alt />
              </div>
              <div class="con_three_top_p">
                <p>《通用合同》</p>
              </div>
              <div class="con_three_top_4">
                <p
                  style="text-indent:25px;line-height:25px;"
                >本协议由甲方和乙方(商企服服务商）在线签订，请甲方仔细阅读协议内容，勾选接受本协议，即意味着已阅读、理解并接受本协议所有条款，并对本协议各条款及相应的法律后果已全部知晓并充分认可。甲方勾选本协议后，即可产生法律约束力。</p>
                <p>一、定义</p>
                <p style="text-indent:25px;">1、商企服平台：指基于商会的综合性企业服务平台，企业服务(商业服务线上交易)是商企服平台中一个重要功能模块。</p>
                <p style="text-indent:25px;">2、用户：指在商企服平台合法注册，接受相关协议、规则、制度等的会员。</p>
                <p style="text-indent:25px;">3、甲方：指在商企服平台上发布服务需求、购买并支付服务的用户。</p>
                <p style="text-indent:25px;">4、乙方：指在商企服平台提供商业服务的用户，即服务商。</p>
                <p style="text-indent:25px;">5、服务需求：指甲方基于自身需求向乙方提出的具体服务要求。</p>
                <p style="text-indent:25px;">6、服务费：指甲方和乙方的交易金额，即本协议约定的交易金额及后续经协商调整后确定的交易总金额。</p>
                <p style="text-indent:25px;">7、平台账户：指用户在商企服平台上注册的账号，用户只能通过该账号登录商企服平台进行交易。</p>
                <p>二、甲方的权利与义务</p>
                <p
                  style="text-indent:25px;"
                >1、甲方应根据服务需求主动向乙方提交该项目所需的相关资料，并保证资料真实、合法、有效，如因甲方未按照前述标准提供资料导致乙方无法履行协议义务的，由此产生的责任由甲方自行承担。</p>
                <p
                  style="text-indent:25px;"
                >2、甲方有权对服务需求对乙方的服务提出建议和思路，同时有权在验收时对乙方的服务成果提出修改意见，但甲方提出的建议或思路及修改意见应当明确具体，如含糊不清，乙方有权不听取甲方建议或拒绝修改，甲方不得借机拖延进度及应支付的款项，甲方提出超出协议约定范围的修改要求，乙方有权拒绝或另行收费。</p>
                <p style="text-indent:25px;">3、甲方应充分了解且同意遵守商企服平台公布的所有协议、规则、制度等，并按照相关规定处理相关交易事项。</p>
                <p
                  style="text-indent:25px;"
                >4、甲方应及时验收乙方交付的服务成果，包括阶段成果和最终成果，如乙方向甲方提交服务成果后7日内甲方未给出具体验收意见的，视为乙方提交的服务成果合格。如有下一阶段服务的，乙方有权继续推进。如下一阶段服务因甲方愿意导致无法继续推进的，乙方不承担任何责任。</p>
                <p style="text-indent:25px;">5、甲方有义务向乙方提供必要的配合义务，包括提供必要的资料、及时验收、及时回复等。</p>
                <p
                  style="text-indent:25px;"
                >6、甲方应保证委托的服务需求不违反任何法律法规或侵犯他人合法权益，否则乙方有权拒绝提供服务并有权立即解除本协议，甲方已支付服务费作为违约金不予退还。</p>
                <p
                  style="text-indent:25px;"
                >7、甲方应保证合法使用乙方提交的服务成果，不得将服务成果用于任何违法违规或侵犯他人合法权益的活动，如甲方违反，应承担全部责任。</p>
                <p
                  style="text-indent:25px;"
                >8、甲方同意本协议仅作为维护交易内容和双方权利义务的基本约定，具体的服务项目、期限、金额等甲方在商企服平台下单时应与乙方进行约定并/或签订相关合同。</p>
                <p
                  style="text-indent:25px;"
                >9、甲方下单时，应仔细确认所需服务内容、价格、数量等信息，下单后即表示甲方对下单信息的认可，支付成功后订单即生效。</p>
                <p
                  style="text-indent:25px;"
                >10、如乙方未在本协议约定期限内完成工作的，甲方有权拒绝支付全部或部分服务费，甲方对已支付的服务费可申请退款，申请退款48小时内，乙方仍不能提交服务成果的，乙方应同意退款。</p>
                <p>三、乙方的权利与义务</p>
                <p style="text-indent:25px;">1、乙方应按照本协议的约定向甲方提供服务。</p>
                <p
                  style="text-indent:25px;"
                >2、乙方应当积极听取甲方的修改意见，对甲方提出的合理需求及明确的修改意见，乙方应在提供服务成果后提供不超过3次的修改服务，但超出协议约定内容的修改需求乙方有权拒绝。</p>
                <p style="text-indent:25px;">3、乙方应该对甲方提供的相关资料承担保密义务，不得向第三方透露。</p>
                <p style="text-indent:25px;">4、乙方有权要求甲方按照协议约定支付相应服务费，如甲方未按照约定支付的，乙方有权利拒绝或顺延提供服务。</p>
                <p
                  style="text-indent:25px;"
                >5、双方约定分阶段工作的，乙方完成阶段性工作，甲方应在7日内予以验收，验收合格后应及时支付该阶段服务费，如未按约定验收，视为验收合格，乙方有权要求甲方支付已完成阶段服务费。</p>
                <p style="text-indent:25px;">6、乙方应按照法律规定自行缴纳相应税费。</p>
                <p>四、服务费流转和发票</p>
                <p style="text-indent:25px;">1、乙方同意委托商汇（天津）信息技术有限公司代为处理服务费事宜。</p>
                <p style="text-indent:25px;">2、乙方应按照甲方最终实际支付服务费为甲方开具合法有效的发票。</p>
                <p>五、知识产权</p>
                <p
                  style="text-indent:25px;"
                >1、本协议所产生的服务成果的知识产权在甲方支付完全部服务费后，归甲方所有。乙方禁止转让该知识产权，但可将服务成果用于案例展示或参加评选。双方另有约定的除外。</p>
                <p style="text-indent:25px;">2、乙方应保证服务成果不存在侵犯第三方的所有权、知识产权、名誉权、肖像权等，并承担因此产生的全部责任。</p>
                <p
                  style="text-indent:25px;"
                >3、甲方的服务需求如需采购第三方知识产权产品的，乙方应及时告知甲方，取得甲方书面同意且支付采购费用后，乙方予以采购并使用，或由甲方自行采购后提供给乙方使用。</p>
                <p
                  style="text-indent:25px;"
                >4、甲方在未付清所有服务费之前，不得使用服务成果，不得主张知识产权。如甲方违反，导致乙方或其他方损失的，甲方应承担因此产生的全部责任。</p>
                <p>六、责任限制</p>
                <p style="text-indent:25px;">乙方依照法律法规履行义务，但对于下述原因导致的合同履行障碍、延后、变更等情况，乙方不承担违约责任：</p>
                <p style="text-indent:25px;">1、因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；</p>
                <p style="text-indent:25px;">2、因电力供应故障、通讯网络故障等公共服务因素或第三人因素；</p>
                <p style="text-indent:25px;">3、在乙方已尽力管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。</p>
                <p>七、违约责任</p>
                <p
                  style="text-indent:25px;"
                >1、乙方未按本协议约定提交服务成果的，应按照服务项目费用总额的1%/天向甲方支付违约金（可在未付款中扣除），延期达15天及以上的，除双方另有约定外，双方均有权解除协议，乙方已收取的服务费应予退还，同时乙方承担违约金。乙方承担责任以收取的服务费为限，仅在已收取的服务费范围内承担责任。</p>
                <p style="text-indent:25px;">2、甲方在服务期间无正当理由单方终止协议的，已支付服务费无权要求返还。</p>
                <p style="text-indent:25px;">3、乙方在服务期间无正当理由单方终止协议的，所收取服务费应当全部返还甲方。</p>
                <p>八、适用法律与争议解决</p>
                <p style="text-indent:25px;">1、本协议及与本协议有关的争议、解释等，均适用中华人民共和国法律。</p>
                <p style="text-indent:25px;">2、本协议履行过程中，如有争议，双方应当友好协商解决；协商不成，双方一致同意提交当地冲裁委员会进行仲裁。</p>
                <p>九、其他</p>
                <p style="text-indent:25px;">1、本协议以电子文本形式生成，双方勾选本协议后，即表示同意本协议，与手签协议具同等法律效力。</p>
                <p style="text-indent:25px;">2、本协议中的任何约定如违反法律法规而无效的，该条款不影响本协议其他条款的效力。</p>
                <p>十、 本协议由商汇（天津）信息技术有限公司解释，自发布之日起实行。</p>
              </div>
              <!-- <div class="con_three_top_5">
                <div class="con_three_bot">
                  <div class="con_p">
                    <p class="con-p">甲方：刘岩</p>
                    <p class="con-p1">签署时间2019/11/19</p>
                  </div>
                  <img src="../../assets/img/dingdan/hetong/pop_icon_contract wqs.png" alt />
                </div>
                <div class="con_three_bot1">
                  <div class="con_p">
                    <p class="con-p">乙方：商汇（天津）信息技术有限公司</p>
                    <p class="con-p1">签署时间2019/11/19</p>
                  </div>
                  <img src="../../assets/img/dingdan/hetong/pop_icon_contract wqs.png" alt />
                </div>
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 拒接验收 -->
    <el-dialog title :visible.sync="dialogVisible1" width="660px" height="443px">
      <div class="acceptance">
        <div class="acceptance_top">
          <p>拒绝验收</p>
        </div>
        <div class="acceptance_cent">
          <p>拒绝理由:</p>
          <p>
            <el-input
              type="textarea"
              :rows="10"
              placeholder="请输入内容"
              v-model="form.refused"
              class="in"
            ></el-input>
          </p>
        </div>
        <div class="acceptance_floor">
          <el-button type="primary" class="botton" @click="Refused()">提交</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 补充需求 -->
    <el-dialog title :visible.sync="dialogVisible2" width="660px" height="443px">
      <div class="acceptance">
        <div class="acceptance_top">
          <p>补充需求</p>
        </div>
        <div class="acceptance_cent">
          <p>补充需求:</p>
          <p>
            <el-input
              type="textarea"
              :rows="10"
              placeholder="请叙述详细完整的任务需求，以便我们更好的为您服务"
              v-model="form.need"
              class="in"
            ></el-input>
          </p>
        </div>
        <div class="acceptance_floor">
          <el-button type="primary" class="botton" @click="needs()">提交</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title :visible.sync="dialogVisible3" width="660px" height="443px">
      <div class="acceptance">
        <div class="acceptance_top">
          <p>追加服务费</p>
        </div>
        <div class="acceptance_cent">
          <div class="content_one2_right1 content_one2_fuwu">
            <p style="padding:0;">订单金额</p>
            <p style="color:#F7681E;font-weight:600;margin-right:50px;">￥{{lists.goods_price}}</p>
            <span>服务商已收</span>
            <span
              style="color:#F7681E;font-weight:600;margin-right:50px;"
            >-￥{{lists.provider_price}}</span>
            <span>托管服务费</span>
            <span style="color:#F7681E;font-weight:600;margin-right:30px;">￥{{lists.host_price}}</span>
          </div>
          <div class="dialog_service">
            <p class="dialog_service_p">追加金额:</p>
            <div class="dialog_service_1">
              <el-input v-model="input" placeholder="请输入预算" class="service_inout"></el-input>
            </div>
          </div>
          <div class="dialog_service_2">
            <img src="../../assets/img/dingdan/pop_icon_sign.png" alt />
            <div class="dialog_service_2_flo">
              <p>托管的服务费将由平台收取，您验收后才会将服务费支付给服务商，为了您的资金安全，请勿线下交易。</p>
            </div>
          </div>
        </div>
        <div class="acceptance_floor">
          <el-button type="primary" class="botton1" @click="needss()">立即追加服务费</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title :visible.sync="dialogVisible4" width="660px" height="443px">
      <div class="acceptance">
        <div class="acceptance_top">
          <p>追加服务费</p>
        </div>
        <div class="pay">
          <div class="pay_img">
            <img :src="add.code_url" alt />
          </div>
          <p>微信扫一扫付款（元）</p>
          <p style="color:#F7681E;font-size:24px;font-weight:600">{{add.edit_price}}</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import {
  finishOrder,
  providerApp,
  refused,
  Acceptance,
  createOrderReply,
  getcontractById,
  Additional,
  orderRemarkAdd,
  getServiceLogList,
  orderDetails,
  contractList,
  getOrderInfo,
  add_price,
  getOrderServiceLog,
  createPdf
} from "@/http/api";
export default {
  data() {
    return {
      value1: "",
      numm: 0,
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      tableData: [
        {
          date: "原型设计阶段",
          name: "我是阶段内容我是阶段内容",
          address: "10 天 ",
          addresss: "1000 元"
        },
        {
          date: "UI&开发阶段",
          name: "我是阶段内容我是阶段内容",
          address: "10 天 ",
          addresss: "1000 元"
        },
        {
          date: "UI&开发阶段",
          name: "我是阶段内容我是阶段内容",
          address: "10 天 ",
          addresss: "1000 元"
        }
      ],
      lists: [],
      form: {
        refused: "",
        need: ""
      },
      input: "",
      getorder: [],
      orderD: [],
      contract: [],
      add: [],
      contracts: []
    };
  },
  methods: {
    // 跳转
    floor() {
      this.$router.push({ name: "guanyu" });
    },
    leimu() {
      this.$router.push({ name: "home" });
    },
    table(index) {
      this.numm = index;
    },
    // finishorder(id) {
    //   this.token = localStorage.getItem("token");
    //   finishOrder({
    //     token: this.token,
    //     order_id: id
    //   }).then(res => {
    //     this.lists = res.data.data;
    //   });
    // },
    orderdetails(id) {
      this.token = localStorage.getItem("token");
      orderDetails({
        token: this.token,
        order_id: id
      }).then(res => {
        this.orderD = res.data.data;
      });
    },
    providerapp(id) {
      this.token = localStorage.getItem("token");
      providerApp({
        token: this.token,
        order_id: id
      });
    },
    getorderInfo(id) {
      this.token = localStorage.getItem("token");
      getOrderInfo({
        token: this.token,
        order_id: id //订单号
      }).then(res => {
        this.lists = res.data.data;
        contractList({
          token: this.token,
          order_id: id,
          contract_type: this.lists.contract_type
        }).then(res => {
          this.contract = res.data.data[0];
          this.contracts = JSON.parse(res.data.data[0].project_phase);
          console.log(this.contracts);
        });
      });
    },
    //拒接验收
    Refused() {
      var id = this.$route.query.order_id;
      this.token = localStorage.getItem("token");
      refused({
        token: this.token,
        order_id: id,
        acceptance_id: this.lists.host_price,
        refused: this.form.refused
      }).then(res => {
        this.refuse = res.data;
        if (this.refuse.errcode == 200) {
          this.dialogVisible1 = false;
        }
      });
    },
    //同意验收
    acceptance() {
      var id = this.$route.query.order_id;
      this.token = localStorage.getItem("token");
      Acceptance({
        token: this.token,
        order_id: id,
        acceptance_id: this.lists.host_price
      }).then(res => {
        console.log(this.order_id);
        if ((res.data.errcode = 200)) {
          this.$router.push({
            name: "wangjie",
            query: {
              id: id
            }
          });
        }
      });
    },
    //补充需求
    needs() {
      var id = this.$route.query.order_id;
      this.token = localStorage.getItem("token");
      createOrderReply({
        order_id: id,
        token: this.token,
        remark_member: this.form.need
      }).then(res => {
        this.dialogVisible2 = false;
      });
    },
    needss(input) {
      this.dialogVisible3 = false;
      this.dialogVisible4 = true;
      var id = this.$route.query.order_id;
      this.token = localStorage.getItem("token");
      // Additional({
      //   order_id: id,
      //   token: this.token,
      //   edit_price: this.input
      // }).then(res => {});
      add_price({
        order_id: id,
        token: this.token,
        edit_price: this.input
      }).then(res => {
        this.add = res.data.data;
        window.setInterval(() => {
          setTimeout(
            getOrderServiceLog({
              token: this.token,
              id: this.add.id
            }).then(res => {
              this.orderinfo = res.data.data;
              if (this.orderinfo.pay_status == 2) {
                this.dialogVisible4 = false;
                this.$router.go(0);
              }
            }),
            0
          );
        }, 3000);
      });
    },
    //需求记录
    getorderRemarkAdd() {
      this.token = localStorage.getItem("token");
      var id = this.$route.query.order_id;
      orderRemarkAdd({
        token: this.token,
        order_id: id
      }).then(res => {
        this.getorder = res.data.data;
      });
    },
    //服务费记录
    getServiceLoglist() {
      this.token = localStorage.getItem("token");
      getServiceLogList({
        token: this.token
      }).then(res => {
        console.log(res);
      });
    },
    //查看合同
    // contractlist(id, lists) {
    //   console.log(this.ists.contract_type);
    //   this.token = localStorage.getItem("token");
    //   contractList({
    //     token: this.token,
    //     order_id: id,
    //     contract_type: lists.contract_type
    //   }).then(res => {
    //     this.contract = res.data.data.start_time;
    //     console.log(this.contract.start_time);
    //     var timestamp = Math.round(new Date().getTime() / 1000).toString(); //10位时间戳
    //     console.log(timestamp)
    //   });
    // },
    //下载合同
    create(contract) {
      this.token = localStorage.getItem("token");
      createPdf({
        token: this.token,
        contract_id: this.contract.id
      }).then(res => {
        console.log(res);
      });
    }
  },
  created() {
    var id = this.$route.query.order_id;
    this.getorderInfo(id);
    this.providerapp(id);
    // this.getContractById();
    this.getorderRemarkAdd();
    this.getServiceLoglist();
    this.orderdetails(id);
    // this.contractlist(id);
    this.$emit("header", true); //是否显示头部
  }
};
</script>

<style scoped>
@import "../../components/style.css";
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
}

.icon {
  color: #000;
}

.top_ul {
  width: 550px;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.cent {
  width: 100%;
  background: #007bff;
}

.cent_1 {
  width: 1200px;
  height: 200px;
  margin: 0 auto;
}

.cent_top {
  width: 100%;
  height: 100px;
  overflow: hidden;
}

.cent_top_content {
  width: 300px;
  height: 62px;
  margin: 20px auto;
}

.cent_top_content img {
  float: left;
  padding: 8px 0;
}

.cent_top_content p {
  line-height: 60px;
  color: #ffffff;
}

.cent_bottom {
  width: 100%;
  height: 100px;
  background: #f4f5f9;
  overflow: hidden;
}

.cent_bottom_1 {
  width: 500px;
  height: 66px;
  margin: 18px auto;
}

.cent_bottom_1 ul li {
  float: left;
  padding: 0 15px;
}

.cent_bottom_1 ul li p {
  font-size: 12px;
  font-weight: 400;
}

.cent_bottom_1 ul li i {
  line-height: 66px;
  font-weight: 600;
}

.content {
  width: 100%;
  height: 1500px;
  background: #f4f5f9;
}

.content_1 {
  width: 1200px;
  margin: 0 auto;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

.content_one {
  width: 100%;
  height: 318px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 7px 0px rgba(244, 245, 249, 1);
}

.content_one1 {
  width: 100%;
  height: 50px;
  margin-bottom: 33px;
}

.content_one1 p:first-child {
  float: left;
  padding: 0 20px;
  border-left: 5px solid #007bff;
  margin-top: 24px;
  font-size: 20px;
  font-weight: 600;
}

.content_one1 p:last-child {
  float: right;
  width: 187px;
  height: 36px;
  background: rgba(0, 123, 255, 1);
  border-radius: 18px 0px 0px 18px;
  margin-top: 24px;
  color: #fff;
  opacity: 0.5;
  font-size: 14px;
  text-align: center;
  line-height: 36px;
}

.content_one2 {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.content_one2_right {
  width: 300px;
  height: 86px;
  border-left: 1px dotted #e4e4e4;
  float: right;
}

.content_one2_right_1 {
  width: 180px;
  height: 86px;
  float: right;
  margin-right: 40px;
}

.content_one2_right1 {
  width: 100%;
  height: 35px;
}

.content_one2_right1 p {
  float: left;
  font-size: 14px;
  margin-bottom: 10px;
}

.content_one2_right1 p:first-child {
  padding: 0 30px;
  color: #999999;
}

.content_one2_left {
  width: 800px;
  height: 190px;
  float: left;
}

.content_one2_right1 span {
  font-size: 14px;
  color: #999999;
}

.fuwudaoqi {
  width: 681px;
  height: 44px;
  background: rgba(255, 228, 227, 1);
  border-radius: 0px 22px 22px 22px;
  overflow: hidden;
  float: right;
  margin-top: 10px;
}

.fuwudaoqi p {
  font-size: 14px;
  color: #ff4d43;
  text-align: center;
  line-height: 44px;
}

.content_two {
  width: 100%;
  height: 60px;
  background: #fff;
  margin-bottom: 31px;
}

.content_botom_1 {
  float: right;
  margin-right: 40px;
}

.bot {
  width: 100px;
  height: 30px;
  background: #f4f5f9;
  outline: 0;
  border: 0;
  color: #222222;
  font-size: 12px;
  margin: 8px 0 0 0;
}

.bot:hover {
  background: #007bff;
  color: #fff;
}

.content_tree {
  width: 100%;
  height: 80px;
  background: #fff;
  overflow: hidden;
  margin-bottom: 30px;
  z-index: -2;
}

.content_tree p {
  font-size: 20px;
  font-weight: 600;
  padding: 0 30px;
  border-left: 5px solid #007bff;
  margin: 30px 0;
  float: left;
}

.content_four_1_1 {
  font-size: 20px;
  font-weight: 600;
  padding: 0 30px;
  border-left: 5px solid #007bff;
  margin: 30px 0;
}

.bott {
  float: right;
  width: 180px;
  height: 44px;
  background: #e4e4e4;
  outline: 0;
  border: 0;
  color: #222222;
  font-size: 12px;
  margin: 18px 40px;
  color: #fff;
}

.content_four {
  width: 100%;
  height: 300px;
  background: #fff;
  overflow: hidden;
  margin-bottom: 30px;
}

.content_four_1 {
  width: 320px;
  height: 719px;
  border-right: 1px solid #e4e4e4;
  overflow: hidden;
  float: left;
}
.content_four_1_2 {
  padding: 0 30px;
  font-size: 14px;
  line-height: 30px;
  color: #999;
}

.content_four_1_2 span {
  padding: 0 30px;
}

.content_four_2 {
  width: 879px;
  height: 300px;
  float: left;
  position: relative;
  overflow: scroll;
}

.content_four_one {
  width: 100%;
  height: auto;
  margin: 34px 0 0 0;
  overflow: hidden;
}

.content_four_one1 {
  overflow: hidden;
}

.content_four_one1 ul li {
  float: left;
  margin: 0 15px;
  margin-bottom: 15px;
}

.content_four_one1 ul li:nth-child(1) {
  width: 102px;
}
.content_four_one1 ul li:nth-child(2) {
  width: 8px;
  height: 8px;
  background: rgba(0, 123, 255, 1);
  border-radius: 50%;
  line-height: 20px;
  margin-top: 10px;
  z-index: 1;
}

.four_one_P {
  font-size: 14px;
  font-weight: 600;
  margin: 0;
}

.four_one_P1 {
  width: 660px;
  font-size: 14px;
  color: #666666;
  margin-bottom: 10px;
}

.four_img {
  width: 80px;
  height: 80px;
  background: #000;
  margin-bottom: 10px;
}
.kong {
  width: 0;
  height: 600px;
  border: 1px solid #e4e4e4;
  position: absolute;
  top: 47px;
  left: 135px;
}

.content_four_1_1p {
  width: 261px;
  height: 135px;
  margin: 0 auto;
  font-size: 14px;
}

.chakan {
  width: 100%;
  height: 84px;
}

.chakan img {
  width: 100%;
  height: 84px;
}

.con {
  width: 100%;
  height: auto;
  background: #00c1de;
}

.con1 {
  width: 100%;
  height: auto;
  background: #00c1de;
}

.con1_1 {
  width: 940px;
  height: auto;
  margin: 0 auto;
  background: #fff;
  border-radius: 10px;
  margin-bottom: 20px;
}

.con_1 {
  width: 940px;
  height: auto;
  margin: 0 auto;
  background: #fff;
  border-radius: 10px;
  margin-bottom: 20px;
}

.con_one {
  width: 100%;
  height: 184px;
  overflow: hidden;
}

.con_one_1 {
  width: 180px;
  height: 30px;
  margin: 0 auto;
  margin-top: 50px;
  margin-bottom: 20px;
}

.con_one_1 img {
  float: left;
  padding: 0 5px;
}

.con_one_1 p {
  float: left;
  font-size: 18px;
  color: #222;
  font-weight: bold;
}

.con_one_2 {
  width: 100%;
  height: auto;
  margin: 0 auto;
  text-align: center;
}

.button_he {
  width: 100px;
  height: 30px;
  line-height: 0;
  background: #00c1de;
  color: #fff;
}

.con_two {
  width: 100%;
  height: 104px;
  margin-bottom: 24px;
}

.con_two_1 {
  width: 840px;
  height: 104px;
  background: rgba(255, 171, 29, 0.05);
  /* opacity: 0.05; */
  margin: 0 auto;
}

.con_two_2 {
  width: 780px;
  height: auto;
  margin: 0 auto;
  overflow: hidden;
}

.con_two_2 p {
  color: #f7681e;
}

.con_two_2 p:first-child {
  font-size: 18px;
  font-weight: bold;
  margin-top: 20px;
}

.con_two_2 p:last-child {
  margin-top: 14px;
}

.con_three {
  width: 100%;
  height: 1768px;
}

.con_three1 {
  width: 100%;
  height: auto;
}

.con_three1_1 {
  width: 840px;
  height: auto;
  margin: 0 auto;
}

.con_three_1 {
  width: 840px;
  height: 1590px;
  margin: 0 auto;
}

.con_three_top {
  width: 100%;
  height: 48px;
  background: #f4f5f9;
  border: 1px solid rgba(228, 228, 228, 1);
  overflow: hidden;
}

.con_three_top p {
  padding: 14px 30px;
  font-weight: bold;
  font-size: 16px;
  color: #222;
}

.con_three_top1 {
  width: 100%;
  height: 217px;
  border: 1px solid rgba(228, 228, 228, 1);
  margin-bottom: 20px;
}

.con_three_top1_p {
  width: 781px;
  margin: 25px 30px;
  color: #222;
}

.content_one2_right1 {
  width: 100%;
  height: 35px;
}

.content_one2_right1 p {
  float: left;
  font-size: 14px;
  margin-bottom: 10px;
  color: #222;
}

.content_one2_right1 p:first-child {
  width: 79px;
  padding: 0 0 0 30px;
}

.content_one2_left {
  width: 800px;
  height: 190px;
  float: left;
}

.con_three_top2 {
  width: 100%;
  height: 200px;
  border: 1px solid rgba(228, 228, 228, 1);
  margin-bottom: 20px;
}

.con_three_top_3 {
  width: 100%;
  height: 103px;
  border: 1px solid rgba(228, 228, 228, 1);
  margin-bottom: 20px;
  overflow: hidden;
}

.con_three_top_3 p {
  width: 781px;
  height: 54px;
  margin: 29px 25px;
  color: #222222;
}

.con_three_top_p {
  width: 100%;
  height: 48px;
  background: #f4f5f9;
  border: 1px solid rgba(228, 228, 228, 1);
}

.con_three_top_p p {
  font-weight: bold;
  font-size: 16px;
  color: #222;
  text-align: center;
  line-height: 48px;
}

.con_three_top_4 {
  width: 100%;
  height: 210px;
  overflow-y: scroll;
  background: rgba(245, 246, 250, 1);
  border: 1px solid rgba(228, 228, 228, 1);
  margin-bottom: 40px;
  /* overflow: hidden; */
}

.con_three_top_4 p:first-child {
  color: #222;
  font-weight: 600;
  margin: 25px 0 0 30px;
}

.con_three_top_4 p:last-child {
  width: 781px;
  color: #222;
  margin: 15px 0 0 30px;
}

.con_three_top_5 {
  width: 100%;
  height: 199px;
}

.con_three_top_5 img:first-child {
  float: left;
}

.con_three_top_5 img:last-child {
  float: right;
}

.content_tree_1 {
  width: 100%;
  height: 286px;
  background: #fff;
  overflow: hidden;
  margin-bottom: 30px;
}

.content_tree_p {
  font-size: 20px;
  font-weight: 600;
  padding: 0 30px;
  border-left: 5px solid #007bff;
  margin: 30px 0;
}

.button {
  width: 180px;
  height: 44px;
  background: #ffffff;
  color: #f7681e;
  border: 1px solid #e4e4e4;
  margin-bottom: 30px;
}

.button:hover {
  background: #f7681e;
  color: #fff;
}

.button_1 {
  width: 180px;
  height: 44px;
  background: #f7681e;
  border: 1px solid #f7681e;
  color: #fff;
}

.button_1:hover {
  background: #ff8c50;
}

.acceptance {
  width: 660px;
  height: 433px;
  background: #fff;
  border-radius: 15px;
}

.acceptance_top {
  width: 100%;
  height: 60px;
  background: #f4f5f9;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.acceptance_top p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(34, 34, 34, 1);
  text-align: center;
  line-height: 60px;
}

.acceptance_cent {
  width: 500px;
  height: 250px;
  margin: 20px auto;
}

.acceptance_cent p:first-child {
  float: left;
  padding: 10px 20px 0 0;
}

.acceptance_cent .in {
  width: 400px;
  height: 209px;
  padding: 10px 0 0 0;
}

.acceptance_floor {
  width: 180px;
  height: 44px;
  margin: 0 auto;
}

.botton {
  width: 180px;
  height: 44px;
}

.botton1 {
  width: 180px;
  height: 44px;
  background: #f7681e;
}

.botton1 {
  width: 180px;
  height: 44px;
  background: #f7681e;
  outline: 0;
  border: 0;
}

.content_one2_fuwu {
  width: 100%;
  height: 80px;
  border-bottom: 1px solid #e4e4e4;
  margin-bottom: 30px;
}

.dialog_service {
  width: 100%;
  height: auto;
}

.dialog_service_p {
  float: left;
}

.dialog_service_1 {
  width: 100%;
}

.service_inout {
  width: 230px;
  height: 36px;
}

.dialog_service_2 img {
  margin: 20px 0 0 100px;
}
.dialog_service_2_flo {
  width: 480px;
  height: 58px;
  background: #f4f5f9;
  margin: -5px 0 0 77px;
}

.dialog_service_2_flo p {
  width: 421px;
  height: 34px;
  margin-left: 25px;
  color: #999999;
}

.pay {
  width: 182px;
  height: 242px;
  border: 1px solid #d3d3d3;
  margin: 40px auto;
}

.pay_img {
  width: 164px;
  height: 164px;
  margin: 9px;
}

.pay p {
  text-align: center;
  margin-top: 3px;
}

.con_three_bot {
  width: 366px;
  height: auto;
  overflow: hidden;
  float: left;
  position: relative;
}

.con_three_bot1 {
  width: 380px;
  height: auto;
  overflow: hidden;
  float: right;
  position: relative;
}

.con_three_bot img {
  width: 232px;
  height: 199px;
  float: right;
  margin-right: 22px;
}

.con_p {
  position: absolute;
  bottom: 30px;
}

.con-p {
  margin-top: 120px;
}

.ul_nian {
  width: 785px;
  height: auto;
  margin: 20px auto;
}

.ul_nian li {
  width: 181px;
  float: left;
}

.ul_nian li p:nth-child(1) {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #222222;
  border-bottom: 0;
}

.ul_nian li p{
  margin-bottom: 20px;
  border-bottom: 1px solid #E4E4E4;
  height: 30px;
}

.ul_nian li:nth-child(2) {
  width: 240px;
}
</style>



// WEBPACK FOOTER //
// src/view/Dingdan/Yuwuzhong.vue